'use client';

import { c as _c } from "react/compiler-runtime";
import cn from 'classnames';
import NextImage from 'next/image';
import { useEffect, useState } from 'react';
import style from './GallerySlideInner.module.scss';
const GallerySlideInner = t0 => {
  const $ = _c(14);
  const {
    url,
    swiper
  } = t0;
  const [width, setWidth] = useState(null);
  const [height, setHeight] = useState(null);
  const getMeta = _temp;
  let t1;
  let t2;
  if ($[0] !== url) {
    t1 = () => {
      getMeta(url, (_, img_0) => {
        setWidth(img_0?.naturalWidth);
        setHeight(img_0?.naturalHeight);
      });
    };
    t2 = [url];
    $[0] = url;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== swiper) {
    t3 = () => {
      if (swiper) {
        swiper.update();
        swiper.slideTo(0);
      }
    };
    $[3] = swiper;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== height || $[6] !== width) {
    t4 = [width, height];
    $[5] = height;
    $[6] = width;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  useEffect(t3, t4);
  const getNameForAlt = _temp2;
  let t5;
  if ($[8] !== height || $[9] !== url || $[10] !== width) {
    t5 = width && height && <>{width >= height && <span className={style.imgWrapperFull}><NextImage className={style.imgFull} src={url} alt={getNameForAlt(url)} fill={true} /></span>}{width < height && <span className={cn(style.imgWrapper, "gallery_slide_inner_wrapper")}><NextImage className={style.img} src={url} alt={getNameForAlt(url)} fill={true} /></span>}</>;
    $[8] = height;
    $[9] = url;
    $[10] = width;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t5) {
    t6 = <>{t5}</>;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
};
export default GallerySlideInner;
function _temp(url_0, cb) {
  const img = new Image();
  img.addEventListener("load", () => cb(null, img));
  img.addEventListener("error", err => cb(err));
  img.src = url_0;
}
function _temp2(url_1) {
  const filenameWithExtension = url_1.slice(url_1.lastIndexOf("/") + 1);
  const filename = filenameWithExtension.split(".")[0];
  return filename;
}